import Box from '@mui/material/Box';
import MuiLinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { formatNumber } from '../../utils/formatNumber/formatNumber';

interface LinearProgressProps {
  value: number;
  showPercentage?: boolean;
}

export const LinearProgress = ({ value, showPercentage = true }: LinearProgressProps) => {
  return (
    <Box sx={{ alignItems: 'center', display: 'flex', gap: 2, mb: 2 }}>
      <Box sx={{ mr: 1, width: '100%' }}>
        <MuiLinearProgress variant="determinate" value={value} />
      </Box>
      {showPercentage ? (
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="secondary">
            {formatNumber(value, { maximumFractionDigits: 0, minimumFractionDigits: 0, style: 'percent' })}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
